module.exports = __webpack_public_path__ + "static/img/video-title.d4a8ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/video-title.png
// module id = CcHz
// module chunks = 1